import { getSessionId, makeGetTouchpoint } from '@redux/memoizedSelectors';
import { pictureValidation } from '@utils/helpers';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Moment from 'react-moment';
import { useSelector } from 'react-redux';
import { FlexContainer, RegularText } from "shared/cx-components/cx-components.style";
import { Flex } from 'shared/ui-basics';
import { PictureContainer, TouchPointLayout } from '../personaInteractions_style';


function HeaderTouchpoints({ channelId, object, updateFunction }) {

    const { t } = useTranslation();

    const touchpoints = useSelector(makeGetTouchpoint(channelId))
    const sessionId = useSelector(getSessionId);
    const picture = pictureValidation(touchpoints, sessionId);
    const { name } = touchpoints || {};
  

    return <Flex gap={16} vertical>
        <TouchPointLayout className='pt-3'>
            <PictureContainer>
                <img src={picture} alt={name?.defaultPlaceholder("NEW_TOUCHPOINT")} />
            </PictureContainer>
            <div className='name ellipsis'>{name}</div>
        </TouchPointLayout>
        <FlexContainer gap={48}>
				<RegularText fontSize="12px" fontWeight={400} color="#595959">
					{t("CREATED_ON")}
					<Moment format="DD MMM, YYYY" date={object?.createdOn} className="ms-1" />
				</RegularText>
				<RegularText fontSize="12px" fontWeight={400} color="#595959">
					{t("UPDATED_ON")}
                <Moment format="DD MMM, YYYY" date={object?.modifiedOn} className="ms-1" />
				</RegularText>
				<RegularText fontSize="12px" fontWeight={400} color="#595959">
					{t("UPDATED_BY")} {object?.modifiedBy}
				</RegularText>
			</FlexContainer>
    </Flex>
}


HeaderTouchpoints.propTypes = {
    channelId: PropTypes.string
};

HeaderTouchpoints.displayName = "HeaderTouchpoints";
export default HeaderTouchpoints;